import axios from "../../utils/axios";
import { API_SUFFIX } from "../../config/app";

// 获取销售人员列表
export function apiSUserlist(query) {
    return axios({
        url: "/admin/index/s_userlist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

//编辑销售人员
export function apiEditsUser(query) {
    return axios({
        url: "/admin/index/edits_user" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 编辑销售人员 提交
export function apiEditsUserSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/edits_user" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 新增销售人员 提交
export function apiAddsUserSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/adds_user" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 获取未关联设备
export function apiAddsUser(query) {
    return axios({
        url: "/admin/index/adds_user" + API_SUFFIX,
        method: "get",
        params: query
    });
}


// 获取销售人员详细
export function apiSUserdetails(query) {
    return axios({
        url: "/admin/index/s_userdetails" + API_SUFFIX,
        method: "get",
        params: query
    });
}